var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09277 8.4043H18.9167",
    stroke: "#929292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80762 12.3098C4.80762 11.8956 5.14341 11.5598 5.55762 11.5598H5.56689C5.9811 11.5598 6.31689 11.8956 6.31689 12.3098C6.31689 12.724 5.9811 13.0598 5.56689 13.0598H5.55762C5.14341 13.0598 4.80762 12.724 4.80762 12.3098ZM10.0044 11.5598C9.59016 11.5598 9.25436 11.8956 9.25436 12.3098C9.25436 12.724 9.59016 13.0598 10.0044 13.0598H10.0136C10.4279 13.0598 10.7636 12.724 10.7636 12.3098C10.7636 11.8956 10.4279 11.5598 10.0136 11.5598H10.0044ZM14.4418 11.5598C14.0276 11.5598 13.6918 11.8956 13.6918 12.3098C13.6918 12.724 14.0276 13.0598 14.4418 13.0598H14.4511C14.8653 13.0598 15.2011 12.724 15.2011 12.3098C15.2011 11.8956 14.8653 11.5598 14.4511 11.5598H14.4418ZM14.4418 15.4463C14.0276 15.4463 13.6918 15.7821 13.6918 16.1963C13.6918 16.6105 14.0276 16.9463 14.4418 16.9463H14.4511C14.8653 16.9463 15.2011 16.6105 15.2011 16.1963C15.2011 15.7821 14.8653 15.4463 14.4511 15.4463H14.4418ZM9.25436 16.1963C9.25436 15.7821 9.59016 15.4463 10.0044 15.4463H10.0136C10.4279 15.4463 10.7636 15.7821 10.7636 16.1963C10.7636 16.6105 10.4279 16.9463 10.0136 16.9463H10.0044C9.59016 16.9463 9.25436 16.6105 9.25436 16.1963ZM5.55762 15.4463C5.14341 15.4463 4.80762 15.7821 4.80762 16.1963C4.80762 16.6105 5.14341 16.9463 5.55762 16.9463H5.56689C5.9811 16.9463 6.31689 16.6105 6.31689 16.1963C6.31689 15.7821 5.9811 15.4463 5.56689 15.4463H5.55762Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0439 1V4.29078",
    stroke: "#929292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96582 1V4.29078",
    stroke: "#929292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2383 2.5791H5.77096C2.83427 2.5791 1 4.21504 1 7.22213V16.2718C1 19.3261 2.83427 20.9999 5.77096 20.9999H14.229C17.175 20.9999 19 19.3545 19 16.3474V7.22213C19.0092 4.21504 17.1842 2.5791 14.2383 2.5791Z",
    stroke: "#929292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.acf3ef7d69ee374c67586a9a555f0578.svg";
export { ForwardRef as ReactComponent };